import { render, staticRenderFns } from "./MoadianTabs.vue?vue&type=template&id=46ee8d29&"
import script from "./MoadianTabs.vue?vue&type=script&lang=js&"
export * from "./MoadianTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports